// THE GRID — gallery paging + garage filtering.
//
// WHY THIS TALKS TO THE SERVER. Liquid can only iterate 50 of the 434 gallery
// metaobjects (`.size` reports the true total; `limit:` does not raise the cap), so
// the old build of this script hid/showed the 50 rendered cards — which meant the
// garage filter searched 12% of the gallery and could say "no builds match" while
// matches existed. Paging, filtering and sorting are therefore all server-side, via
// the App Proxy. See docs/gallery-pagination.md.
//
// The server-rendered first page stays as the no-JS / proxy-unreachable fallback:
// nothing here destroys it until a successful response is in hand.
(function () {
  var root = document.querySelector("[data-pl-grid]");
  if (!root) return;
  var wrap = root.querySelector("[data-pl-cards]");
  var sortSel = root.querySelector("[data-pl-sort]");
  var countEl = root.querySelector("[data-pl-count]");
  var emptyEl = root.querySelector("[data-pl-empty]");
  var noteEl = root.querySelector("[data-pl-garage-note]");
  var moreBtn = root.querySelector("[data-pl-more]");
  var filterBtn = root.querySelector("[data-pl-filter-toggle]");
  var wrapEl = root.querySelector("[data-pl-garage-wrap]");
  var join = wrap.querySelector(".pl-build-card--join");

  var ENDPOINT = "/apps/titan/gallery/builds";
  // Declared by the section so Liquid and the proxy cannot drift. They used to:
  // Liquid rendered 50 against a 24-per-page proxy, so the first "Load more"
  // could not simply append page 2 without duplicating rows 25-48.
  var PER_PAGE = Number(root.dataset.plGridPerPage) || 24;
  var total = Number(root.dataset.plGridTotal || 0);
  // Count the DOM, never `builds.size`: that reports the true total (434) even though
  // Liquid only rendered 50 — the same `.size` lie behind this whole feature.
  var rendered = wrap.querySelectorAll(".pl-build-card:not(.pl-build-card--join)").length;
  var page = 1;          // last page currently displayed
  var filterMake = "", filterModel = "";
  var serverMode = false; // true once we have replaced the Liquid-rendered page
  var busy = false;

  function slug(s) {
    return String(s == null ? "" : s).trim().toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
  }
  function t(key, fallback) {
    var el = root.querySelector("[data-pl-i18n-" + key + "]");
    return (el && el.textContent.trim()) || fallback;
  }
  function setNote(msg) {
    if (!noteEl) return;
    noteEl.textContent = msg || "";
    noteEl.hidden = !msg;
  }
  // Kept in step with app/extensions/titan-garage/assets/seen-on-builds.js's esc() —
  // separate bundles, no shared module, but they must escape the same set (L-1).
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (ch) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[ch];
    });
  }

  // Only a same-origin relative path is a safe href (L-2). These URLs are
  // server-derived today (galleryBuildPath()), but the same field could one day
  // carry an Instagram/TikTok link, and esc() alone does nothing about scheme —
  // a "javascript:" value would render as a working link.
  function safeUrl(u) {
    var s = String(u == null ? "" : u);
    return /^\/(?![/\\])/.test(s) ? s : "#";
  }

  // Mirrors snippets/pitlane-build-card.liquid. Kept deliberately small: only the
  // fields the proxy returns, so the two cannot drift far.
  function cardHtml(b) {
    var media = b.image
      ? '<img class="pl-build-card__img" src="' + esc(b.image) + '" alt="' + esc(b.title) + '" loading="lazy">'
      : "";
    var flag = b.featured ? '<span class="pl-build-card__flag">' + esc(t("featured", "FEATURED")) + "</span>" : "";
    var cat = b.category ? '<span class="pl-build-card__cat">' + esc(b.category) + "</span>" : "";
    var verified = b.verified
      ? ' · <span class="pl-build-card__verified">' + esc(t("verified", "VERIFIED")) + "</span>"
      : "";
    // Mirrors snippets/pitlane-build-card.liquid: the vehicle is the headline, the
    // title falls back only when there is no vehicle data, and the owner line is
    // dropped when it would only repeat the headline. Keep the two in step.
    var heading = b.vehicleDisplay || b.title;
    var by = b.displayHandle && b.displayHandle !== heading
      ? '<p class="pl-build-card__by">' + esc(b.displayHandle) + "</p>"
      : "";
    return (
      '<a href="' + esc(safeUrl(b.url)) + '" class="pl-build-card">' +
      // DIV, not span, and this matters. `.pl-build-card__media` relies on
      // `aspect-ratio: 16 / 10` and `.pl-build-card__body` on padding — an INLINE
      // element ignores aspect-ratio and does not establish a block box, so the
      // image took its own size and the text underneath collapsed behind it. The
      // Liquid card always used divs; this copy did not, so cards looked right
      // until the first "Load more" replaced them.
      '<div class="pl-build-card__media">' + media + flag + cat + "</div>" +
      '<div class="pl-build-card__body">' +
      '<p class="pl-build-card__meta">' + esc(t("equipped", "TITAN-EQUIPPED")) + verified + "</p>" +
      '<h3 class="pl-build-card__title">' + esc(heading) + "</h3>" + by +
      "</div></a>"
    );
  }

  function url(p) {
    var q = "?page=" + p + "&perPage=" + PER_PAGE + "&sort=" + (sortSel ? sortSel.value : "featured");
    if (filterMake) q += "&make=" + encodeURIComponent(filterMake);
    if (filterModel) q += "&model=" + encodeURIComponent(filterModel);
    return ENDPOINT + q;
  }

  function fetchPage(p) {
    return fetch(url(p), { headers: { Accept: "application/json" } }).then(function (r) {
      if (!r.ok) throw new Error("proxy " + r.status);
      return r.json();
    });
  }

  // Restores scroll after a replace. Removing nodes above the viewport is what
  // made "Load more" jump to the top of the page.
  function keepingScroll(fn) {
    var y = window.scrollY;
    fn();
    if (window.scrollY !== y) window.scrollTo(0, y);
  }

  function setBusy(on) {
    root.setAttribute("aria-busy", on ? "true" : "false");
    wrap.classList.toggle("is-pl-loading", !!on);
  }

  function paint(data, append) {
    if (!append) {
      Array.prototype.slice.call(wrap.querySelectorAll(".pl-build-card:not(.pl-build-card--join)"))
        .forEach(function (c) { c.remove(); });
    }
    // Every append is deduped, not just the first click. Liquid's page is in
    // insertion order, so the builds it drew resurface scattered across later
    // server pages; without this they would appear a second time.
    var list = append ? dedupe(data.builds) : data.builds;
    var html = list.map(cardHtml).join("");
    if (join) join.insertAdjacentHTML("beforebegin", html);
    else wrap.insertAdjacentHTML("beforeend", html);
    total = data.total;
    if (countEl) countEl.textContent = String(total);
    if (emptyEl) emptyEl.hidden = total > 0;
    if (moreBtn) moreBtn.hidden = !data.hasMore;
    serverMode = true;
  }

  function load(p, append) {
    if (busy) return Promise.resolve();
    busy = true;
    if (moreBtn) { moreBtn.disabled = true; moreBtn.textContent = t("loading", "Loading…"); }
    if (!append) setBusy(true);
    return fetchPage(p)
      .then(function (data) {
        page = p;
        if (append) paint(data, true);
        else keepingScroll(function () { paint(data, false); });
      })
      .catch(function () {
        // Leave whatever is on screen — the Liquid page, or the last good result.
        if (moreBtn) moreBtn.hidden = true;
      })
      .then(function () {
        busy = false;
        setBusy(false);
        if (moreBtn) { moreBtn.disabled = false; moreBtn.textContent = t("load_more", "Load more builds"); }
      });
  }

  // Tiered garage match, resolved against SERVER counts rather than rendered cards:
  //   1) make + model   2) make only   3) full gallery
  // `interactive` means the shopper just acted (cleared the filter, re-applied it,
  // changed vehicle) rather than the page having just loaded. It decides whether
  // "unfiltered" needs a fetch:
  //   on load  — the server already rendered every build, so there is nothing to do
  //   on click — the DOM currently holds FILTERED results, so they must be replaced
  // Missing that distinction was the bug RJ hit: "clicking show all builds doesn't
  // remove the filter." The state flipped, the button relabelled, and the filtered
  // cards sat there untouched.
  function applyGarage(v, interactive) {
    paintFilterBtn(v);

    if (!v || !v.make) {
      filterMake = ""; filterModel = ""; setNote("");
      return interactive || serverMode ? load(1, false) : Promise.resolve();
    }

    var mk = slug(v.make), md = v.model ? slug(v.model) : "";
    var label = vehicleLabel(v);
    var prettyMake = String(v.make).replace(/-/g, " ").toUpperCase();

    filterMake = mk; filterModel = md;

    // Say what is happening BEFORE the request. On first load the Liquid page is
    // unfiltered, so without this the grid silently redraws a moment later and
    // reads as the page loading twice.
    //
    // When the pre-paint script already restored this vehicle's cached result,
    // say nothing and show nothing: the grid on screen is already right, and this
    // pass is a silent revalidation. Announcing it would reintroduce exactly the
    // flicker the cache exists to remove.
    if (!(prime.primed && prime.key === cacheKey())) {
      setNote("Finding " + label + " builds…");
      setBusy(true);
    }

    function show(note, data) {
      setNote(note);
      // Silent revalidation after a cache hit: if the server agrees with what is
      // already on screen, touch nothing. This is the common case on a repeat
      // visit and is what makes it read as a single load.
      if (!sameAsDom(data)) keepingScroll(function () { paint(data, false); });
      else { total = data.total; if (countEl) countEl.textContent = String(total); if (moreBtn) moreBtn.hidden = !data.hasMore; serverMode = true; }
      setBusy(false);
      wrap.classList.remove("is-pl-priming");
      cacheWrite(note, data);
    }

    return fetchPage(1).then(function (d) {
      if (d.total > 0) return show("Showing " + label + " builds — all years.", d);
      filterModel = "";
      return fetchPage(1).then(function (d2) {
        if (d2.total > 0) return show("No " + label + " builds yet — showing all " + prettyMake + " builds.", d2);
        filterMake = "";
        return fetchPage(1).then(function (d3) {
          show("No " + prettyMake + " builds yet — showing the full gallery.", d3);
        });
      });
    }).catch(function () {
      // Proxy unreachable: leave whatever is on screen and say nothing misleading
      // about it being filtered. If we hid the server's cards pre-paint, show them
      // again — an unfiltered grid beats a blank one.
      setNote("");
      setBusy(false);
      wrap.classList.remove("is-pl-priming");
    });
  }

  // A garage vehicle filters the gallery AUTOMATICALLY (RJ, 2026-09-14), with an
  // explicit way to show everything again.
  //
  // History, so this does not get flipped a third time. It was auto-apply, then
  // opt-in on 2026-09-11 to kill the visible "double load", now auto-apply again.
  // Auto-apply is safe NOW and was not then: the pre-paint script plus the session
  // cache mean a repeat visit paints the filtered grid before first paint instead
  // of correcting it afterwards. Opting in was solving a problem that no longer
  // exists, and with the YMM selector sitting directly above it, a second "filter
  // by my vehicle" control read as a duplicate of the thing above it.
  //
  // Clearing NEVER touches titan.garage: "show all builds here" and "forget my
  // vehicle" are different asks, and the garage is shared with the PDP, collections
  // and the header. sessionStorage, so it does not outlive the visit.
  var CACHE_KEY = "titan.gallery.cache";

  // The pre-paint script in the section may already have restored a filtered grid
  // from this cache. See the comment there for why that has to happen inline.
  var prime = window.__plGridPrime || { primed: false, key: null };

  function cacheKey() {
    var v = readGarage();
    if (!v || !v.make) return null;
    return v.make + "|" + (v.model || "") + "|" + (sortSel ? sortSel.value : "featured");
  }
  // Handles currently on screen, in order. Used to decide whether a revalidation
  // actually changed anything — repainting identical cards is invisible but not
  // free, and it throws away image decode work for no reason.
  function domHandles() {
    return Array.prototype.slice
      .call(wrap.querySelectorAll("a.pl-build-card:not(.pl-build-card--join)"))
      .map(function (a) { return (a.getAttribute("href") || "").split("/").pop(); })
      .join(",");
  }
  // Drops builds already on screen. The server's page 1 overlaps whatever Liquid
  // drew, and without this the first click would show some builds twice.
  function dedupe(builds) {
    var seen = {};
    domHandles().split(",").forEach(function (h) { if (h) seen[h] = 1; });
    return builds.filter(function (b) {
      if (seen[b.handle]) return false;
      seen[b.handle] = 1;
      return true;
    });
  }

  function sameAsDom(data) {
    return data.builds.map(function (b) { return b.handle; }).join(",") === domHandles();
  }

  function cacheWrite(note, data) {
    var k = cacheKey();
    if (!k) return;
    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({
        key: k, html: wrap.innerHTML, note: note || "",
        total: data.total, hasMore: !!data.hasMore,
      }));
    } catch (e) { /* quota or private mode: caching is an optimisation, not a contract */ }
  }

  // A VEHICLE BEING ACTIVE IS THE FILTER (RJ, 2026-09-15). There is no separate
  // on/off flag — that made two states where one would do, and no part of the UI
  // could express "selected but not filtering" without a second control.
  //
  // "Show all builds" DEACTIVATES the vehicle. It stays saved in the garage, so
  // re-applying is picking it again there.
  //
  // GO THROUGH window.TitanGarage WHEN IT EXISTS. Writing localStorage directly
  // left the app block's in-memory state stale: the grid updated, the bar and
  // header chip kept showing the vehicle until a reload or a page change, because
  // the block re-reads storage only when it boots (RJ hit exactly this). The block
  // owns the state; the theme asks it. The direct write stays as the fallback for a
  // store that has not placed the embed.
  function showAll() {
    if (window.TitanGarage && typeof window.TitanGarage.clearActive === "function") {
      window.TitanGarage.clearActive();
      return;
    }
    try {
      var raw = localStorage.getItem("titan.garage");
      if (!raw) return;
      var g = JSON.parse(raw);
      g.activeId = null;
      localStorage.setItem("titan.garage", JSON.stringify(g));
      document.dispatchEvent(new CustomEvent("titan:garage:change", { detail: g }));
    } catch (e) { /* storage unavailable: nothing to deactivate */ }
  }


  // "2019 Ford F-150" -> "Ford F-150". The year is dropped because the filter is
  // make/model across all years; showing a year we are not filtering on is a lie.
  function vehicleLabel(v) {
    if (!v) return "";
    return String(v.label || (v.make + " " + (v.model || ""))).replace(/^\s*\d{4}\s+/, "").trim();
  }

  // Does the fitment bar provide a FILTER TOGGLE on this page?
  //
  // Not "is a bar present" — that was the bug RJ hit. The theme half of the
  // consolidation shipped before the app extension, so the grid hid its own
  // controls in deference to a bar control that did not exist yet, and the gallery
  // lost the only way to stop filtering. So this asks for the CONTROL ITSELF, at
  // paint time: if the bar's ✕ is on the page, it owns clearing and the grid's
  // button stands down; if it isn't, the grid keeps its own (RJ, 2026-09-22 —
  // same shape as the collection pages).
  function barProvidesToggle() {
    return !!document.querySelector("[data-tg-fitbar] [data-tg-filter-toggle]");
  }
  function paintFilterBtn(vehicle) {
    var on = !!(vehicle && vehicle.make);
    if (wrapEl) wrapEl.classList.toggle("is-pl-filtered", on);
    if (!filterBtn) return;
    // One control, one meaning: while a vehicle is selected the grid is filtered,
    // and this is how you stop. Hidden otherwise, because there is nothing to undo.
    filterBtn.hidden = !on || barProvidesToggle();
    if (!filterBtn.hidden) filterBtn.textContent = t("show_all", "Show all builds");
  }

  function readGarage() {
    try {
      var s = JSON.parse(localStorage.getItem("titan.garage") || "{}");
      if (!s.vehicles) return null;
      return s.vehicles.filter(function (v) { return v.id === s.activeId; })[0] || null;
    } catch (e) { return null; }
  }

  if (moreBtn) {
    // Only offer paging once we know there is more than the server rendered.
    moreBtn.hidden = !(total > rendered);
    moreBtn.addEventListener("click", function () {
      if (serverMode) return load(page + 1, true);

      // FIRST CLICK. The button must ADD, exactly like every click after it.
      // RJ: "The first time it's clicked, it appears to replace what's there, then
      // clicking it again, loads more below."
      //
      // The awkwardness is real: Liquid rendered its page in metaobject insertion
      // order, the proxy orders by featured-then-published, and the two do not
      // agree. The previous build reconciled that by re-fetching page 1 and
      // repainting — correct, and visibly a replace.
      //
      // Instead: fetch server pages 1 AND 2, drop anything already on screen, and
      // APPEND the rest. Page 1 is fetched, not skipped, because builds that sort
      // into the server's first page but were not in Liquid's 24 would otherwise
      // never be reachable. Nothing on screen moves; the grid only grows.
      //
      // The trade is ordering, not completeness: the first 24 keep Liquid's order
      // and everything after is server-sorted. Changing the sort still does a full
      // replace, which is what a sort is supposed to do.
      busy = true;
      if (moreBtn) { moreBtn.disabled = true; moreBtn.textContent = t("loading", "Loading…"); }
      return Promise.all([fetchPage(1), fetchPage(2)])
        .then(function (r) {
          var merged = r[0].builds.concat(r[1].builds);
          paint({ builds: merged, total: r[1].total, hasMore: r[1].hasMore }, true);
          page = 2;
        })
        .catch(function () { if (moreBtn) moreBtn.hidden = true; })
        .then(function () {
          busy = false;
          if (moreBtn) { moreBtn.disabled = false; moreBtn.textContent = t("load_more", "Load more builds"); }
        });
    });
  }
  if (sortSel) sortSel.addEventListener("change", function () {
    // A different sort invalidates the cached page — it was stored per sort, but
    // the key includes it, so this simply writes a new entry on the next paint.
    load(1, false);
  });

  // "Show all builds" deactivates the vehicle rather than setting a flag. The
  // garage:change listener below then re-runs applyGarage, which sees no active
  // vehicle and loads the unfiltered page — the same path as a shopper who never
  // picked a car.
  if (filterBtn) filterBtn.addEventListener("click", showAll);

  var active = readGarage();
  paintFilterBtn(active);

  if (prime.primed && prime.cache) {
    // The DOM already holds a real server result. Adopt it as state so "Load more"
    // pages on from here instead of restarting.
    serverMode = true;
    page = 1;
    total = prime.cache.total;
    if (countEl) countEl.textContent = String(total);
    if (moreBtn) moreBtn.hidden = !prime.cache.hasMore;
    if (prime.cache.note) setNote(prime.cache.note);
    var v0 = readGarage();
    filterMake = v0 ? slug(v0.make) : "";
    filterModel = v0 && v0.model ? slug(v0.model) : "";
  }

  if (active) applyGarage(active);

  // One listener for everything that can change the vehicle: picked in the bar,
  // switched in the drawer, removed, or deactivated by "Show all builds".
  document.addEventListener("titan:garage:change", function () {
    applyGarage(readGarage(), true);
  });
})();
